var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "cargo-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.previewFileData.visible,
        "can-maximize": _vm.canMaximize,
        "custom-class": "common-preview-dialog",
        "append-to-body": ""
      },
      on: { close: _vm.closePreviewDialog, fullscreen: _vm.fullscreenChange }
    },
    [
      _vm.previewFileData.pdfSrc
        ? _c(
            "div",
            { staticClass: "pdf-img" },
            [
              _c(
                "el-scrollbar",
                _vm._l(_vm.previewFileData.numPages, function(i) {
                  return _c("pdf", {
                    key: i,
                    attrs: { src: _vm.previewFileData.pdfSrc, page: i }
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.previewFileData.excelSrc
        ? _c(
            "div",
            { class: _vm.isMax ? "max-plus-class" : "" },
            [
              _c("excel", {
                key: _vm.dialogKey,
                class: !_vm.isMax ? "office-preview" : "",
                attrs: { src: _vm.previewFileData.excelSrc }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.previewFileData.wordSrc
        ? _c(
            "div",
            [
              _c(
                "el-scrollbar",
                [
                  _c("doc", {
                    staticClass: "office-preview",
                    attrs: { src: _vm.previewFileData.wordSrc }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.previewFileData.txtPre
        ? _c("div", [_vm._v(_vm._s(_vm.previewFileData.txtPre))])
        : _vm.previewFileData.photoList.length > 0
        ? _c(
            "viewer",
            {
              staticClass: "preview-img",
              attrs: { images: _vm.previewFileData.photoList }
            },
            _vm._l(_vm.previewFileData.photoList, function(item, index) {
              return _c("img", { key: index, attrs: { src: item } })
            }),
            0
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }